export const SearchBoxDialogTitle = '詳細検索';
